import React from "react";
import ReactPaginate from "react-paginate";
// import ArrowRight from "../Assets/img/arrow_right.svg";
// import ArrowLeft from "../Assets/img/Arrow_left.svg";
export default function Pagination({
  pageNumber,
  perPage,
  paginationList,
  pageRange,
  pageCount,
  handlePageClick,
  paginationClass, onPageActive
}) {
  const imageUrl = "./assets/images/";
  return (
    <div className="mt-4 px-3 store-pagination">
      <div
        className={`flex items-center justify-center ${paginationClass}`}
      >
        <ReactPaginate
          breakLabel="..."
          previousLabel={<img src={imageUrl + "back.svg"} alt="" />
          }
          nextLabel={<img src={imageUrl + "back.svg"} alt="" className="rotate-180" />}
          pageRangeDisplayed={3}
          marginPagesDisplayed={1}
          pageCount={pageCount}
          onPageChange={handlePageClick}
          containerClassName={"pagination"}
          previousLinkClassName={"pagination__link"}
          nextLinkClassName={"pagination__link"}
          disabledClassName={"pagination__link--disabled"}
          activeClassName={"pagination__link--active"}
          pageClassName="pagination-list"
          onPageActive={onPageActive}
        // forcePage={onPageActive - 1}
        />
      </div>
    </div>
  );
}
